<div class="d-flex flex-column align-items-center w-100 text-center">
  <input
    #fileInput
    (change)="onUploadImage($event)"
    [hidden]="true"
    accept="image/*"
    name="files"
    type="file"
  />

  <button
    (click)="fileInput.click()"
    [disabled]="disabled"
    color="primary"
    mat-raised-button
    type="button"
  >
    {{ "SHARED.IMAGE_PICKER.ADD_IMAGE" | translate }}
  </button>
  <div class="w-100 mt-4" style="height: 4px">
    <mat-progress-bar
      *ngIf="isUploading$ | async"
      mode="determinate"
      [value]="uploadProgress$ | async"
    ></mat-progress-bar>
  </div>
</div>
